import { QueryStringService } from '@amarkets/atlas/esm/lib/query-string';
import { omit } from '@amarkets/atlas/esm/lib/omit';

export default function getCurrentUrlWithoutCode(currentUrl) {
  const { url, query } = QueryStringService.parseUrl({ url: currentUrl });
  const resultUrl = QueryStringService.stringifyUrl({ urlObject: { url, query: omit(query, 'code') } });

  return encodeURIComponent(resultUrl);
}
